/** Merge fields a campaign can personalise per recipient — must match the backend's
 *  MERGE_FIELDS (app/domains/mailing_management/service.py). Stored in the body as
 *  `{{ token }}`; rendered as pills in the editor. */
export const MERGE_FIELDS: { token: string; label: string }[] = [
  { token: "first_name", label: "First name" },
  { token: "last_name", label: "Last name" },
  { token: "email", label: "Email" },
  { token: "city", label: "City" },
];
